import { render } from "./EditAssessment.vue?vue&type=template&id=f45a9858&scoped=true"
import script from "./EditAssessment.vue?vue&type=script&lang=js"
export * from "./EditAssessment.vue?vue&type=script&lang=js"

import "./EditAssessment.vue?vue&type=style&index=0&id=f45a9858&scoped=true&lang=css"

import exportComponent from "/home/hohte/projects/lms/frontend/production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f45a9858"]])

export default __exports__